<template>
  <!-- Always in the prerendered HTML, hidden unless the head script below marked
       <html> for a powered_by visit, so it is decided before first paint and the
       hero never shifts while the page loads. English homepage only. -->
  <p
    v-if="isDefaultLocale"
    class="powered-by-strip m-0 mb-4 w-full max-w-2xl rounded-md bg-slate-950 px-4 py-2 text-[13px] leading-5 text-white shadow-sm dark:bg-white dark:text-slate-950 sm:mb-1 sm:text-sm"
    data-powered-by-strip
  >
    <span class="sm:hidden">Found us via a customer?</span>
    <span class="hidden sm:inline">You found us through a business that runs on Workspace369. Get the same invoices, proposals and client portal for yours.</span>
    <a
      class="ml-1 whitespace-nowrap font-semibold underline underline-offset-2"
      :href="addReferralToUrl('https://app.workspace369.com/signup')"
      data-conversion-event="start_free_click"
      data-conversion-label="Powered-by referral strip"
      data-conversion-location="home-powered-by-strip"
    >{{ homeCopy.hero.primaryCta }}</a>
    <span class="ml-1">{{ trialTerms }}</span>
  </p>
</template>

<script setup lang="ts">
import pricing from '~/data/pricing-features.json';
import { POWERED_BY_HEAD_SCRIPT } from '~/utils/tracking/poweredBy';

// Visitors who clicked a "Powered by Workspace369" credit on a client's
// invoice, proposal, portal or email land on the homepage with
// utm_source=powered_by (369.dev PoweredByWorkspace, API poolBranding).
// They get one line saying how they got here, with the hero's own CTA.
const { addReferralToUrl } = useReferral();
const { isDefaultLocale } = useWorkspaceLocale();
const homeCopy = useHomeCopy();
const { tr } = useHomeI18n();

// The link starts the same signup as the hero CTA, with no plan chosen, so the terms
// beside it name the lowest post-trial price, like the hero's TrialDisclosure (B1.1).
const trialTerms = computed(() =>
  tr('(card required, then from {price}/month until you cancel)').replace('{price}', `$${pricing.plans[0].monthly}`),
);

useHead({
  script: [{ key: 'w369-powered-by', innerHTML: POWERED_BY_HEAD_SCRIPT, tagPosition: 'head' }],
});
</script>

<style>
/* Unscoped on purpose: the rule keys off a class on <html>, which a scoped
   :global() selector cannot combine with this component's own class. */
.powered-by-strip {
  display: none;
}

html.w369-powered-by .powered-by-strip {
  display: block;
}
</style>
